<template>
    <v-container max-width="1200" >

        <v-card class="mb-6" variant="outlined">
            <v-card-title id="emails" >
                Email Signature
            </v-card-title>
            <v-card-text v-if="editedDefs.emails">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="editedDefs.emails!.forward_to" label="Forward Email" hint="This email address will receive all sent emails" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="editedDefs.emails!.reply_to" label="Reply Email" hint="This email will be used to receive emails from customers" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-textarea v-model="editedDefs.emails!.signoff" label="Conclusion" hint="We take pride in our work..." />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="editedDefs.emails!.signature" label="Regards" hint="Kind Regards, ..." />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn :disabled="!changes.emails" color="success" variant="tonal" @click="update('emails')">Update</v-btn>
            </v-card-actions>
        </v-card>


        <v-card  class="mb-6" variant="outlined">
            <v-card-title id="finance">
                Payment Details
            </v-card-title>
            <v-card-text v-if="editedDefs.finance">
                <v-row>
                    <v-col >
                        <v-text-field v-model="editedDefs.finance!.billing_line_one" label="Address" hint="Your billing address line one" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col >
                        <v-text-field v-model="editedDefs.finance!.billing_city" label="City" hint="Your billing address city" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="editedDefs.finance!.billing_postcode" label="Postcode" hint="Your billing address postcode" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                    <v-divider/>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-text-field v-model="editedDefs.finance!.payment_bank" label="Bank" hint="Name of bank" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="editedDefs.finance!.payment_name" label="Name" hint="Account holder's name" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="editedDefs.finance!.payment_account" label="Account-Number" hint="Your bank account number" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="editedDefs.finance!.payment_sortcode" label="Sort-Code" hint="You sort code" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn :disabled="!changes.finance" color="success" variant="tonal" @click="update('finance')">Update</v-btn>
            </v-card-actions>
        </v-card>

         <v-card  class="mb-6" variant="outlined">
            <v-card-title id="prefs">
                Preferences
            </v-card-title>
            <v-card-text v-if="editedDefs.prefs">
                <v-row>
                    <v-col cols="12" md="6">
                        <v-number-input  v-model="editedDefs.prefs!.default_payment_window" label="Payment Window" hint="Number of days from issue date" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-number-input  v-model="editedDefs.prefs!.default_payment_warnings" label="Overdue Payment Warnings" hint="Number of warnings that will be sent after overdue date" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-number-input  v-model="cron_invoice_reminders" label="Invoice Reminder Time" hint="Remind at this hour of day" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-number-input  v-model="cron_archive" label="Archive Check Time" hint="Check invoices for archiving at this hour of day" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-checkbox v-model="editedDefs.prefs!.bcc_auto_reminders" label="Forward Automated payment reminders?" hint="Automated warning emails sent to clients will also be forwarded to you" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn :disabled="!changes.prefs" color="success" variant="tonal" @click="update('prefs')">Update</v-btn>
            </v-card-actions>
        </v-card>

        <v-card  v-if="editedDefs.links" v-for="linkKey of Object.keys(editedDefs.links!)" class="mb-6" variant="outlined">
            <v-card-title id="images">Image: {{ linkKey }}</v-card-title>
            <v-card-text class="overflow-x-auto text-center">
                <v-dialog max-width="800" @after-leave="file = null">
                    <template #activator="{ props }">
                        <img v-bind="props" class="ma-2" style="max-height: 300px;" :src="(editedDefs.links as any)[linkKey]" :alt="linkKey" />
                    </template>
                    <template #default="{ isActive }">
                        <v-card>
                            <v-card-text>
                                <v-file-upload scrim="primary" v-model="file"></v-file-upload>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn @click="isActive.value = false">Back</v-btn>
                                <v-spacer/>
                                <v-btn :disabled="!file" variant="tonal" color="success"
                                    @click="upload(linkKey, isActive)">Continue</v-btn>
                            </v-card-actions>
                        </v-card>
                    </template>
                </v-dialog>
            </v-card-text>
        </v-card>

        <v-btn variant="tonal" to="/">Back</v-btn>
    </v-container>
</template>

<script setup lang="ts">
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import { Defaults } from '@shared/schema'
import axios from 'axios'
import { repo } from 'remult'
import { nextTick, onMounted, reactive, Ref, ref, toRaw, watch } from 'vue'
import { inject } from 'vue'
import { useRouter } from 'vue-router'
import { User } from 'firebase/auth'
import { scrollToElement } from '@/hooks'

const router = useRouter()
const showSnackbar = inject('snackbar') as (message: string, color: string) => void;
const appBarTitle = inject('appBarTitle') as Ref<string>
appBarTitle.value = 'Upload Images'

const user = inject('user') as Partial<User>

const defs = ref<Partial<Defaults>>({})
const editedDefs = reactive<Partial<Defaults>>({})
const cron_archive = ref()
const cron_invoice_reminders = ref()

const changes = ref({
    emails: false,
    finance: false,
    prefs: false,
})
watch(
    () => editedDefs.emails,
    (newVal) => {
        const sn = JSON.stringify(newVal) 
        const so = JSON.stringify(defs.value.emails)
        changes.value.emails = sn !== so
    },
    { deep: true, immediate: false }
)
watch(
    () => editedDefs.finance,
    (newVal) => {
        const sn = JSON.stringify(newVal) 
        const so = JSON.stringify(defs.value.finance)
        changes.value.finance = sn !== so
    },
    { deep: true, immediate: false }
)
watch(
    () => editedDefs.prefs,
    (newVal) => {
        const sn = JSON.stringify(newVal) 
        const so = JSON.stringify(defs.value.prefs)
        changes.value.prefs = sn !== so
    },
    { deep: true, immediate: false }
)
watch(
    cron_archive,
    (newVal) => {
        changes.value.prefs = true
    },
    { immediate: false }
)
watch(
    cron_invoice_reminders,
    (newVal) => {
        changes.value.prefs = true
    },
    { immediate: false }
)

const file = ref()

onMounted(async () => {
    const acc = (await repo(Defaults).findFirst({ platform: import.meta.env.VITE_PLATFORM }))!
    defs.value = structuredClone(acc)
    Object.assign(editedDefs, structuredClone(acc))
    console.log(editedDefs)
    cron_archive.value = parseInt(editedDefs.prefs!.cron_archive)
    cron_invoice_reminders.value = parseInt(editedDefs.prefs!.cron_invoice_reminders)
    nextTick(()=>{
    changes.value.emails = false
    changes.value.prefs = false
    changes.value.finance = false
    scrollToElement(router.currentRoute.value.path.split('#')[1])
    })
})

async function update(fields: 'emails' | 'finance' | 'prefs'){
    if(fields === 'prefs'){
        editedDefs.prefs!.cron_archive = cron_archive.value
        editedDefs.prefs!.cron_invoice_reminders = cron_invoice_reminders.value
        
    }
    const item = editedDefs[fields]
   
    await repo(Defaults).update(editedDefs.id!, {[fields]:item})
    showSnackbar('Updated','success')

    if(fields === 'prefs'){
        await axios.post('/api/cron-reset')    
    }

    defs.value = structuredClone(toRaw(editedDefs))
    changes.value[fields] = false
}

async function upload(tag: string, modalProps: any) {
    const formData = new FormData();
    formData.append('image', file.value);
    const r = await axios.put('/api/cms/image/' + tag,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

    if (r.status === 200) {
        console.log(r.data.link)
        const links = editedDefs.links as any
        links[tag] = r.data.link + '?ts=' + Date.now()
        showSnackbar("Upload ok", "success")
    }
    else {
        showSnackbar("Failed uploading image", "error")
    }
    modalProps.value = false
}

</script>

<style scoped>
.cms-images-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
}

.images-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 2rem;
}

.images-table th,
.images-table td {
    border: 1px solid #ddd;
    padding: 0.5rem;
    text-align: left;
}

.image-preview {
    max-width: 100px;
    max-height: 60px;
    object-fit: contain;
    border: 1px solid #ccc;
    background: #fafafa;
}

.edit-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background: #fff;
    padding: 2rem;
    border-radius: 8px;
    min-width: 300px;
}

.modal-actions {
    margin-top: 1rem;
    display: flex;
    gap: 1rem;
}
</style>
